import merge from 'lodash/merge';
import {ThemeBuildType, ThemeVariablesType} from '@yosmanyga/theme';

export const build: ThemeBuildType = (variables, prev) => {
    const {palette} = variables as ThemeVariablesType;

    const current = {
        text: {
            color: palette.neutral['1000'],
            quote_intent: {
                margin: {
                    left: 2,
                    right: 2,
                },
            },
            signature_intent: {
                margin: {
                    left: 2,
                    right: 2,
                },
                align: {
                    self: 'flex-end',
                },
            },
        },
    };

    return merge(
        {},
        prev ? prev(variables) : {},
        current
    );
};
